import ListBook from "./ListBook";
import StatusWantToRead from "./StatusWantToRead";
import StatusRead from "./StatusRead";
import StatusCurrentlyReading from "./StatusCurrentlyReading";
import StatusStopped from "./StatusStopped";
import Note from "./Note";
import Quote from "./Quote";
import Rated from "./Rated";
import Reviewed from "./Reviewed";
import ReferredTo from "./ReferredTo";
import ReferredBy from "./ReferredBy";
import ProgressUpdated from "./ProgressUpdated";
import PromptBook from "./PromptBook";
import UserBookReadStarted from "./UserBookReadStarted";
import UserBookReadFinished from "./UserBookReadFinished";

// type ReadingJournalEventComponentType = ({ journal }:{ journal: ReadingJournalType }) => React.ReactElement;

const JournalEventMap = {
  status_want_to_read: StatusWantToRead,
  status_currently_reading: StatusCurrentlyReading,
  status_read: StatusRead,
  status_stopped: StatusStopped,
  note: Note,
  quote: Quote,
  rated: Rated,
  reviewed: Reviewed,
  referral_to: ReferredTo,
  referred_by: ReferredBy,
  progress_updated: ProgressUpdated,
  list_book: ListBook,
  prompt_book: PromptBook,
  user_book_read_started: UserBookReadStarted,
  user_book_read_finished: UserBookReadFinished,
};

export default JournalEventMap;
